<template>
  <div class="main-container">
    <!-- 左侧导航 -->
    <div class="sidebar">
      <!-- 顶部logo区域 -->
      <div class="logo-container">
        <img :src="shopLogo" alt="站点端" class="logo-img" />
        <h1 class="logo-title" v-if="!isCollapse">{{ shopName }}</h1>
      </div>

      <!-- 左侧导航 -->
      <el-menu class="nav-menu" :default-active="activeMenu" :background-color="menuBgColor" text-color="#a0a8b8"
        active-text-color="#00f2fe" router :collapse="isCollapse" unique-opened>
        <!-- 控制台 -->
        <el-menu-item index="/dashboard">
          <el-icon>
            <Monitor />
          </el-icon>
          <span>控制台</span>
        </el-menu-item>

        <!-- 企鹅广告 -->
        <el-sub-menu index="/txad" v-if="showTxadMarketing">

          <template #title>
            <el-icon>
              <DataAnalysis />
            </el-icon>
            <span>企鹅广告</span>
          </template>


          <!-- 账号管理 -->
          <el-menu-item index="/txad/account">
            <el-icon>
              <User />
            </el-icon>
            <span>广告账户</span>
          </el-menu-item>

          <!-- 广告商管理 -->
          <el-menu-item index="/txad/Advertiser">
            <el-icon>
              <Document />
            </el-icon>
            <span>广告管理</span>
          </el-menu-item>

          <el-menu-item index="/txad/CustomAudienceManagement">
            <el-icon>
              <Connection />
            </el-icon>
            <span>人群管理</span>
          </el-menu-item>

          <el-menu-item index="/txad/ScheduledDelivery">
            <el-icon>
              <Promotion />
            </el-icon>
            <span>定时投放</span>
          </el-menu-item>

        </el-sub-menu>



        <!-- 邮件营销 - 根据 smart_card_mail 控制显示 -->
        <el-sub-menu v-if="showEmailMarketing" index="/email">
          <template #title>
            <el-icon>
              <Message />
            </el-icon>
            <span>邮件营销</span>
          </template>

          <el-menu-item index="/email/EmailAccount">
            <el-icon>
              <Message />
            </el-icon>
            <span>邮箱账户</span>
          </el-menu-item>

          <el-menu-item index="/email/EmailTemplate">
            <el-icon>
              <Edit />
            </el-icon>
            <span>邮件模版</span>
          </el-menu-item>

          <el-menu-item index="/email/EmailTestRecord">
            <el-icon>
              <List />
            </el-icon>
            <span>测试记录</span>
          </el-menu-item>

          <el-menu-item index="/email/ScheduledEmail">
            <el-icon>
              <Promotion />
            </el-icon>
            <span>定时任务</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 模版消息 -->
        <el-sub-menu index="/wxmessage" v-if="showMbxxMarketing">
          <template #title>
            <el-icon>
              <ChatDotRound />
            </el-icon>
            <span>模版消息</span>
          </template>

          <el-menu-item index="/wxmessage/WechatAccount">
            <el-icon>
              <User />
            </el-icon>
            <span>账户管理</span>
          </el-menu-item>
        </el-sub-menu>

        <el-menu-item index="/NumberManagement">
          <el-icon>
            <Phone />
          </el-icon>
          <span>号码管理</span>
        </el-menu-item>

        <el-sub-menu index="/store">
          <template #title>
            <el-icon>
              <Shop />
            </el-icon>
            <span>个人中心</span>
          </template>

          <el-menu-item index="/store/usermanagement">
            <el-icon>
              <UserFilled />
            </el-icon>
            <span>用户信息</span>
          </el-menu-item>

          <el-menu-item index="/store/businesscard">
            <el-icon>
              <CreditCard />
            </el-icon>
            <span>名片管理</span>
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>

    <!-- 右侧内容区 -->
    <div class="content-wrapper">
      <!-- 固定在顶部的导航栏 -->
      <div class="top-navbar fixed-top">
        <div class="nav-center">
          <div class="info-item expire">
            <el-icon class="icon">
              <Calendar />
            </el-icon>
            <span class="label">过期时间:</span>
            <span class="value">{{ formattedOutDate }}</span>
          </div>
        </div>

        <div class="nav-right">
          <el-dropdown trigger="hover">
            <div class="user-info">
              <el-avatar :size="30" :src="userAvatar" />
              <span class="username">{{ username }}</span>
              <el-icon class="arrow-icon">
                <ArrowDown />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="handleModifyPassword">
                  <el-icon>
                    <Edit />
                  </el-icon>修改密码
                </el-dropdown-item>
                <el-dropdown-item divided @click="handleLogout">
                  <el-icon>
                    <SwitchButton />
                  </el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <!-- 主内容区 -->
      <div class="main-content-container">
        <div class="main-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>

  <!-- 修改密码对话框 -->
  <el-dialog v-model="showPasswordDialog" title="修改密码" width="400px" :close-on-click-modal="false">
    <el-form :model="form" label-width="80px">
      <el-form-item label="旧密码">
        <el-input v-model="form.oldPwd" type="password" placeholder="请输入旧密码" show-password />
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="form.newPwd" type="password" placeholder="请输入新密码" show-password />
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input v-model="form.confirmPwd" type="password" placeholder="请再次输入新密码" show-password />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showPasswordDialog = false">取 消</el-button>
      <el-button type="primary" @click="submitPassword">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {
  Monitor,
  User,
  Document,
  CreditCard,
  Shop,
  UserFilled,
  Promotion,
  Connection,
  Phone,
  Message,
  Edit,
  ChatDotRound,
  DataAnalysis,
  List
} from '@element-plus/icons-vue'
import { ref, computed, onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import config from '@/config'
import axios from 'axios'
import { Calendar } from '@element-plus/icons-vue'

export default {
  name: 'MainLayout',
  components: {
    Monitor,
    CreditCard,
    User,
    Document,
    Calendar,
    Shop,
    UserFilled,
    Promotion,
    Connection,
    Phone,
    Message,
    Edit,
    ChatDotRound,
    DataAnalysis,
    List
  },

  setup() {
    const router = useRouter()

    const userInfo = JSON.parse(Cookies.get('pc_user_info') || '{}')
    const phone = userInfo.phone || ''
    const storeId = userInfo.store_id || ''
    const userId = userInfo.id || ''
    const isLoggedIn = ref(!!Cookies.get('pc_user_token'))
    const shopLogo = ref('@/assets/logo.gif')
    const shopName = ref('PC管理端')
    const menuBgColor = ref('transparent')
    const isCollapse = ref(false)
    const points = ref(0)
    const sqNum = ref(0)
    const outDate = ref('')
    const formattedOutDate = computed(() => outDate.value.split(' ')[0] || '未设置')
    const userAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')
    const username = ref(phone)

    // 新增：控制邮件营销导航显示
    const showEmailMarketing = ref(false)
    const showTxadMarketing = ref(false)
    const showMbxxMarketing = ref(false)

    const activeMenu = computed(() => {
      const route = router.currentRoute.value
      const matched = route.matched
      return matched.length > 1 ? `/${matched[0].path.split('/')[1]}` : route.path
    })
    const showPasswordDialog = ref(false)
    const form = reactive({
      oldPwd: '',
      newPwd: '',
      confirmPwd: ''
    })

    // 加载点数数据和权限信息
    const loadPoints = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/shop_api.php`, {
          action: 'query',
          store_id: storeId,
          user_id: userId
        })

        if (response.data.success) {
          points.value = parseFloat(response.data.data.dianshu || 0)
          sqNum.value = parseInt(response.data.data.sq_num) || 0
          outDate.value = response.data.data.out_date || ''

          // 检查邮件营销权限
          const applicationMarket = response.data.data.application_market || {}
          showEmailMarketing.value = applicationMarket.smart_card_mail === true
          showTxadMarketing.value = applicationMarket.smart_card_pyqgg === true
          showMbxxMarketing.value = applicationMarket.smart_card_mbxx === true

          console.log('邮件营销权限:', showEmailMarketing.value, applicationMarket)
        } else {
          ElMessage.error('点数加载失败: ' + (response.data.message || '未知错误'))
        }
      } catch (error) {
        ElMessage.error('接口请求失败: ' + error.message)
      }
    }

    // 修改密码方法
    const submitPassword = async () => {
      if (!form.oldPwd) {
        ElMessage.error('请输入旧密码')
        return
      }
      if (!form.newPwd) {
        ElMessage.error('请输入新密码')
        return
      }
      if (form.newPwd !== form.confirmPwd) {
        ElMessage.error('两次输入的新密码不一致')
        return
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/shop_api.php`, {
          action: 'update_password',
          store_id: storeId,
          user_id: userId,
          old_password: form.oldPwd,
          new_password: form.newPwd
        })

        if (response.data.success) {
          ElMessage.success('密码修改成功，请重新登录')
          // 清除登录状态
          Cookies.remove('pc_user_token')
          Cookies.remove('pc_user_info')
          router.push('/login')
        } else {
          ElMessage.error(response.data.message || '密码修改失败')
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '请求失败')
      } finally {
        showPasswordDialog.value = false
      }
    }

    // 修改密码按钮点击事件
    const handleModifyPassword = () => {
      Object.assign(form, {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      })
      showPasswordDialog.value = true
    }

    // 加载店铺信息
    const loadShopInfo = async () => {
      try {
        let storeId = null;

        // 方法1：从 URL 查询参数获取 store_id
        const urlParams = new URLSearchParams(window.location.search);
        storeId = urlParams.get('store_id');

        // 方法2：如果查询参数没有，从哈希参数获取
        if (!storeId) {
          const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
          storeId = hashParams.get('store_id');
        }

        console.log('获取到的 store_id:', storeId); // 调试用

        const response = await axios.get(`${config.BASE_URL}/pc/api/web_icon.php`, {
          params: {
            store_id: storeId
          }
        })

        if (response.data.success) {
          // 注意：接口返回的字段名是 pc_logo 和 pc_title，不是 shop_logo 和 shop_name
          shopLogo.value = response.data.data.pc_logo || '@/assets/logo.gif'
          shopName.value = response.data.data.pc_title || 'PC管理端'
        }
      } catch (error) {
        console.error('加载店铺信息失败:', error)
        shopLogo.value = '@/assets/logo.gif'
        shopName.value = 'PC管理端'
      }
    }

    onMounted(() => {
      loadPoints()
      loadShopInfo()
    })

    const handleNavClick = (type) => {
      const messages = {
        distribution: '分销中心正在开发中，请稍后...',
        discount: '优惠套餐正在开发中，请稍后...'
      }
      ElMessage.info(messages[type] || '功能开发中')
    }

    const handleLogout = async () => {
      try {
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        Cookies.remove('pc_user_token')
        Cookies.remove('pc_user_info')
        isLoggedIn.value = false

        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }

    return {
      menuBgColor,
      isCollapse,
      points,
      userAvatar,
      username,
      activeMenu,
      sqNum,
      formattedOutDate,
      showEmailMarketing, // 新增：导出邮件营销显示控制
      showTxadMarketing,
      showMbxxMarketing,
      handleLogout,
      handleNavClick,
      showPasswordDialog,
      form,
      submitPassword,
      shopLogo,
      shopName,
      userInfo,
      handleModifyPassword
    }
  }
}
</script>



<style scoped lang="scss">
.main-container {
  display: flex;
  /* 改为深空黑金主题 */
  background: linear-gradient(135deg,
      #0a0a0a 0%,
      #1a1a1a 25%,
      #2d2d2d 50%,
      #1f1f1f 75%,
      #121212 100%);
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

// 添加科技感背景效果 - 改为金色
.main-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 80%, rgba(212, 175, 55, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(184, 134, 11, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(218, 165, 32, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

// 添加网格背景 - 改为金色
.main-container::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(rgba(212, 175, 55, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(212, 175, 55, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}

.sidebar {
  width: 220px;
  /* 侧边栏背景改为深灰金色 */
  background: linear-gradient(195deg,
      rgba(20, 20, 20, 0.95) 0%,
      rgba(40, 40, 40, 0.9) 50%,
      rgba(25, 25, 25, 0.85) 100%);
  backdrop-filter: blur(10px);
  box-shadow:
    4px 0 25px rgba(0, 0, 0, 0.3),
    inset -1px 0 0 rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(212, 175, 55, 0.1);
  position: relative;
  z-index: 10;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .logo-container {
    padding: 28px 0;
    border-bottom: 1px solid rgba(212, 175, 55, 0.15);
    text-align: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 25%;
      width: 50%;
      height: 2px;
      background: linear-gradient(90deg,
          transparent 0%,
          #d4af37 50%,
          transparent 100%);
    }

    .logo-img {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      box-shadow:
        0 8px 25px rgba(212, 175, 55, 0.3),
        0 0 0 1px rgba(212, 175, 55, 0.2);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      filter: brightness(1.1);
    }

    .logo-title {
      margin: 16px 0 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 1px;
      /* 标题改为金色渐变 */
      background: linear-gradient(135deg, #d4af37 0%, #f4d03f 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 2px 10px rgba(212, 175, 55, 0.3);
    }
  }
}

.nav-menu {
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: rgba(212, 175, 55, 0.08);
  text-color: #a0a8b8;
  active-text-color: #d4af37;
  padding: 16px 12px;
  height: auto;
  position: relative;

  :deep(.el-submenu__title),
  :deep(.el-menu-item) {
    height: 50px;
    margin: 6px 0;
    border-radius: 12px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 0 20px !important;
    display: flex !important;
    align-items: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 3px;
      background: linear-gradient(180deg, #d4af37 0%, #f4d03f 100%);
      transform: scaleY(0);
      transition: transform 0.3s ease;
    }

    .el-icon {
      font-size: 18px;
      flex-shrink: 0;
      width: 24px;
      margin-right: 12px;
      color: #a0a8b8;
      transition: all 0.3s ease;
    }

    &:hover {
      background: rgba(212, 175, 55, 0.08) !important;
      transform: translateX(8px);
      box-shadow: 0 4px 15px rgba(212, 175, 55, 0.2);

      .el-icon {
        color: #d4af37;
        transform: scale(1.1);
      }

      &::before {
        transform: scaleY(1);
      }
    }
  }

  :deep(.el-sub-menu) {
    .el-sub-menu__icon-arrow {
      right: 12px !important;
      margin-top: -7px !important;
      color: #a0a8b8;
      transition: all 0.3s ease;
    }

    .el-sub-menu__title span {
      margin-left: -1px;
    }

    &:hover .el-sub-menu__icon-arrow {
      color: #d4af37;
    }
  }

  :deep(.el-menu-item .el-icon),
  :deep(.el-sub-menu__title .el-icon) {
    margin-right: 12px !important;
  }

  :deep(.el-menu-item)>span,
  :deep(.el-submenu__title)>span {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  :deep(.el-menu-item.is-active) {
    background: linear-gradient(90deg,
        rgba(212, 175, 55, 0.15) 0%,
        rgba(244, 208, 63, 0.05) 100%) !important;
    box-shadow:
      inset 0 0 20px rgba(212, 175, 55, 0.1),
      0 4px 15px rgba(212, 175, 55, 0.2);

    &::before {
      transform: scaleY(1);
    }

    .el-icon {
      color: #d4af37;
    }
  }

  :deep(.el-sub-menu) {
    .el-menu-item {
      padding-left: 52px !important;
      position: relative;

      &::before {
        left: 20px;
        width: 2px;
        background: linear-gradient(180deg, #f4d03f 0%, #d4af37 100%);
      }
    }

    .el-menu-item.is-active {
      padding-left: 50px !important;
    }
  }
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.fixed-top {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 70px;
  background: rgba(20, 20, 20, 0.85);
  backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(212, 175, 55, 0.15);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  box-shadow:
    0 4px 30px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);

  .nav-center {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-left: auto;

    .info-item {
      display: flex;
      align-items: center;
      padding: 10px 20px;
      border-radius: 12px;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
      backdrop-filter: blur(10px);
      border: 1px solid transparent;
      background: linear-gradient(135deg,
          rgba(255, 255, 255, 0.1) 0%,
          rgba(255, 255, 255, 0.05) 100%);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg,
            transparent,
            rgba(255, 255, 255, 0.1),
            transparent);
        transition: left 0.6s ease;
      }

      .icon {
        font-size: 16px;
        margin-right: 10px;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
      }

      .label {
        font-weight: 600;
        margin-right: 6px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
      }

      .value {
        font-weight: 700;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
      }

      &.points {
        color: #d4af37;
        border-color: rgba(212, 175, 55, 0.3);
        box-shadow:
          0 4px 15px rgba(212, 175, 55, 0.2),
          inset 0 1px 0 rgba(212, 175, 55, 0.1);

        .icon {
          color: #d4af37;
        }
      }

      &.auth {
        color: #27ae60;
        border-color: rgba(39, 174, 96, 0.3);
        box-shadow:
          0 4px 15px rgba(39, 174, 96, 0.2),
          inset 0 1px 0 rgba(39, 174, 96, 0.1);

        .icon {
          color: #27ae60;
        }
      }

      &.expire {
        color: #e74c3c;
        border-color: rgba(231, 76, 60, 0.3);
        box-shadow:
          0 4px 15px rgba(231, 76, 60, 0.2),
          inset 0 1px 0 rgba(231, 76, 60, 0.1);

        .icon {
          color: #e74c3c;
        }
      }

      &:hover {
        transform: translateY(-3px);
        box-shadow:
          0 8px 25px rgba(212, 175, 55, 0.3),
          inset 0 1px 0 rgba(255, 255, 255, 0.2);

        &::before {
          left: 100%;
        }
      }
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    padding: 10px 18px;
    border-radius: 15px;
    transition: all 0.3s ease;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(212, 175, 55, 0.3);
      box-shadow: 0 4px 15px rgba(212, 175, 55, 0.2);
      transform: translateY(-2px);
    }

    .el-avatar {
      box-shadow:
        0 4px 12px rgba(212, 175, 55, 0.3),
        0 0 0 1px rgba(212, 175, 55, 0.2);
    }

    .username {
      margin-left: 12px;
      font-size: 14px;
      font-weight: 600;
      color: #e0e6ff;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    }

    .arrow-icon {
      margin-left: 8px;
      color: #a0a8b8;
      font-size: 12px;
      transition: transform 0.3s ease;
    }
  }
}

.main-content-container {
  flex: 1;
  overflow-y: auto;
  background: transparent;
  position: relative;

  .main-content {
    background: rgba(20, 20, 20, 0.6);
    backdrop-filter: blur(20px);
    box-shadow:
      0 8px 40px rgba(0, 0, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.05);
    padding: 0px;
    min-height: 100vh;
    border: 1px solid rgba(212, 175, 55, 0.1);
    position: relative;
  }
}

// 自定义滚动条
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #d4af37 0%, #f4d03f 100%);
  border-radius: 6px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

::-webkit-scrollbar-corner {
  background: transparent;
}

.el-menu {
  border-right: none
}

// 响应式设计
@media (max-width: 768px) {
  .sidebar {
    width: 80px;

    .logo-title {
      display: none;
    }
  }

  .fixed-top .nav-center {
    gap: 10px;

    .info-item {
      padding: 8px 12px;
      font-size: 12px;
    }
  }
}
</style>